import { useContext } from "react";
import { EditablePageContext } from "../components/EditablePage";
export default function useBuilder({ config, }) {
    const { selectedWidget, setSelectedWidget, handleMoveUp, handleMoveDown, handleDeleteBlock, blockOrder, deletedBlockIds } = useContext(EditablePageContext);
    return {
        selectedWidget,
        setSelectedWidget,
        handleMoveUp,
        handleMoveDown,
        handleDeleteBlock,
        blockOrder,
        deletedBlockIds
    };
}
